
document.addEventListener('DOMContentLoaded', () => {

    /////general animation
    const animatedElements = document.querySelectorAll('.fade-up-on-scroll');  
    const observerCallback = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
            }
        });
    };

    const observerOptions = {
        root: null, 
        rootMargin: '0px', 
        threshold: 0.05
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    animatedElements.forEach(element => {
        observer.observe(element);
    });


    ///apply class in body
    const element = document.getElementById('targetElement');            
    const delayMs = 1000; 

    setTimeout(() => {
        if (element) {
            element.classList.add('is-loaded');
            console.log('Class is-loaded applied after 1.5 seconds.');
        }
    }, delayMs);



    // DISABLED: Default auto product selector - was forcing subscription option on longform product
    // and overriding URL-based selection. Selection is now controlled by longform-product.liquid
    // (syncAppstleFromUrl: first option when no ?variant=, else option from URL).
    // if(document.querySelector('.main-pro-sec') && document.querySelector('.main-pro-sec').classList.contains('template-product-longform')){
    //     var isALARendered;
    //     function ALAcheck() { isALARendered = setInterval(customALA, 200); }
    //     ALAcheck();
    //     function customALA() {
    //         var selector = document.querySelector('.appstle_sub_widget');
    //         if(selector) {
    //             clearInterval(isALARendered);
    //             const subs_widget = document.querySelector('.appstle_sub_widget');
    //             if(subs_widget){
    //                 const subs_plan_input = subs_widget.querySelector('.appstle_subscription_wrapper_option.appstle_include_dropdown input[type="radio"]');
    //                 if(subs_plan_input){ subs_plan_input.checked = true; }
    //             }
    //         }
    //     }
    // }
        

});



document.addEventListener('DOMContentLoaded', function () {
  const giftModals = document.querySelectorAll('.sub-gifts-modal');
  if (!giftModals.length) return;

  function isMobileSheet() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function openGiftModal(modal) {
    if (!modal) return;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sub-gifts-modal-open');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        modal.classList.add('is-open');
      });
    });
    const dialog = modal.querySelector('.sub-gifts-modal__dialog');
    if (dialog) dialog.focus();
  }

  function closeGiftModal(modal) {
    if (!modal || modal.hidden) return;
    const dialog = modal.querySelector('.sub-gifts-modal__dialog');
    let closed = false;

    function finishClose() {
      if (closed) return;
      closed = true;
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      modal.classList.remove('is-open');
      if (!document.querySelector('.sub-gifts-modal:not([hidden])')) {
        document.body.classList.remove('sub-gifts-modal-open');
      }
    }

    modal.classList.remove('is-open');

    if (isMobileSheet() && dialog) {
      const onEnd = function (event) {
        if (event.propertyName !== 'transform') return;
        dialog.removeEventListener('transitionend', onEnd);
        finishClose();
      };
      dialog.addEventListener('transitionend', onEnd);
      setTimeout(finishClose, 400);
    } else {
      finishClose();
    }
  }

  document.querySelectorAll('[data-sub-gifts-open]').forEach(function (button) {
    button.addEventListener('click', function () {
      const modalId = button.getAttribute('aria-controls');
      const modal = modalId
        ? document.getElementById(modalId)
        : button.closest('.sub-gifts-block').querySelector('.sub-gifts-modal');
      openGiftModal(modal);
    });
  });

  document.querySelectorAll('[data-sub-gifts-close]').forEach(function (button) {
    button.addEventListener('click', function () {
      closeGiftModal(button.closest('.sub-gifts-modal'));
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.sub-gifts-modal:not([hidden])').forEach(closeGiftModal);
  });
});
